export default "__VITE_ASSET__BTy$NiU1__"